import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { map, filter, scan , mergeMap} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppTitleService {

  sub: Subscription;
  appName: string;
  title: string;
  pageTitle: string;
  constructor(private activatedRoute: ActivatedRoute, private titleService: Title, private router: Router,
              private translate: TranslateService) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.activatedRoute.firstChild;
        while (child){
          if (child.firstChild){
            child = child.firstChild;
          }else if (child.snapshot.data && child.snapshot.data.title){
            return child.snapshot.data.title;
          }else{
            return null;
          }
        }
        return null;
      })
    ).subscribe( (data: any) => {
      if (data !== null && data !== undefined) {
        this.pageTitle = this.translate.instant(data);
        this.title = this.translate.instant(data);
        this.titleService.setTitle('QLNS | ' + this.title);
      } else {
        this.titleService.setTitle('QLNS');
      }
    });
   }
}
